const env = {
  apiUrl: 'https://eva-hom.pefisa.com.br/api/ceaportal/',
  language: 'pt',
};

export default env;
